import { axiosClient } from '../../libs/axios';

export const MAILING_SUBSCRIBE = '[MAILING APP] SUBSCRIBE';
export const MAILING_UNSUBSCRIBE = '[MAILING APP] UNSUBSCRIBE';
export const MAILING_ERROR = '[MAILING APP] ERROR';
export const MAILING_RESET_MESSAGE = '[MAILING APP] RESET MESSAGE';
export const MAILING_LOADING = '[MAILING APP] LOADING';
export const MAILING_LOADED = '[MAILING APP] LOADED';

export function mailingSubscribe(email) {
    return dispatch => {
        dispatch({
            type: MAILING_RESET_MESSAGE
        });
        dispatch({
            type: MAILING_LOADING
        });

        return axiosClient.post(
            `/api/restaurant/${window.vendor}/mailing/subscribe`,
            {email}
        )
        .then(response => {
            if (response.data.error) {
                dispatch({
                    type: MAILING_ERROR,
                    payload: response.data.error
                });
            }
            else {
                dispatch({
                    type: MAILING_SUBSCRIBE,
                    payload: response.data
                });
            }
            dispatch({
                type: MAILING_LOADED
            });
        })
    }
}

export function mailingUnsubscribe(email) {
    return dispatch => {
        dispatch({
            type: MAILING_RESET_MESSAGE
        });
        dispatch({
            type: MAILING_LOADING
        });

        return axiosClient.post(
            `/api/restaurant/${window.vendor}/mailing/unsubscribe`,
            {email}
        )
        .then(response => {
            if (response.data.error) {
                dispatch({
                    type: MAILING_ERROR,
                    payload: response.data.error
                });
            }
            else {
                dispatch({
                    type: MAILING_UNSUBSCRIBE,
                    payload: response.data
                });
            }
            dispatch({
                type: MAILING_LOADED
            });
        })
    }
}